import { Cable, Hand, AlertTriangle, Layers } from "lucide-react";

const brokerCls = "bg-[hsl(192_55%_45%/0.15)] text-[hsl(192_55%_70%)] border-[hsl(192_55%_45%/0.35)]";
const csvCls    = "bg-[hsl(268_45%_55%/0.15)] text-[hsl(268_45%_75%)] border-[hsl(268_45%_55%/0.35)]";
const enrichedCls = "bg-[hsl(122_39%_49%/0.15)] text-[hsl(122_39%_65%)] border-[hsl(122_39%_49%/0.35)]";

const MAP = {
  "Manuell":                { label: "Manuell",   Icon: Hand,           cls: "bg-secondary text-foreground/80 border-border" },
  "Manuell (angereichert)": { label: "Manuell+API", Icon: Layers,       cls: enrichedCls },
  "OKX":                    { label: "OKX",       Icon: Cable,          cls: brokerCls },
  "Bitget":                 { label: "Bitget",    Icon: Cable,          cls: brokerCls },
  "Binance":                { label: "Binance",   Icon: Cable,          cls: brokerCls },
  "Kraken":                 { label: "Kraken",    Icon: Cable,          cls: brokerCls },
  "Bitunix":                { label: "Bitunix",   Icon: Cable,          cls: brokerCls },
  "LeveX":                  { label: "LeveX",     Icon: Cable,          cls: csvCls },
  "IBKR API":               { label: "IBKR API",  Icon: Cable,          cls: "bg-[hsl(210_25%_45%/0.18)] text-[hsl(210_25%_78%)] border-[hsl(210_25%_45%/0.35)]" },
  "Bitpanda":               { label: "Bitpanda",  Icon: Cable,          cls: brokerCls },
  "Konflikt":               { label: "Konflikt",  Icon: AlertTriangle,  cls: "bg-[hsl(32_60%_55%/0.15)] text-[hsl(32_60%_72%)] border-[hsl(32_60%_55%/0.4)]" },
};

export default function ProvenanceBadge({ source = "Manuell", label, testid }) {
  const cfg = MAP[source] || MAP.Manuell;
  const { Icon } = cfg;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border ${cfg.cls}`}
      data-testid={testid}
      title={label ? `${cfg.label} · ${label}` : cfg.label}
    >
      <Icon className="h-3 w-3" strokeWidth={1.5} />
      {cfg.label}
      {label && <span className="text-[10px] opacity-80 ml-0.5">· {label}</span>}
    </span>
  );
}
